import { render, staticRenderFns } from "./ShiftVDPJournalForm.vue?vue&type=template&id=1b1a6a9b&"
import script from "./ShiftVDPJournalForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPJournalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports